module.exports = __webpack_public_path__ + "static/media/loader.d63084a6.svg";